'use client';

import { twMerge } from 'tailwind-merge';

import { IComponentGenericFormField } from '@/types/cms';
import { IGenericInquiryFormProps } from '../types';

import { BaseField, BaseMessages, BaseSMSField, BaseSubmit, BaseSubscribeField, BaseTermsField } from './Base';

// --

const styles = {
  container: 'leading-none grow relative',
  label:
    'absolute left-2 top-5 pointer-events-none leading-none text-black-400 text-sm text-left [&>span]:text-md [&>span]:leading-none transition-all group-focus-within:left-0 group-focus-within:top-0 group-focus-within:-translate-y-0 group-focus-within:text-xs transition-all',
  labelWithValue: 'left-0 top-0 -translate-y-0 text-xs',
  input:
    'leading-none px-0 pt-5 border-x-0 border-t-0 rounded-none focus:outline-none focus:ring-0 focus:border-black-500',
};

// --

interface IStyleSimpleFormProps extends IGenericInquiryFormProps {
  fieldsMapped: {
    [field: string]: IComponentGenericFormField;
  };
  wasSuccessful: boolean;
  wasError: boolean;
}

export const StyleSimpleForm = (props: IStyleSimpleFormProps) => {
  const fieldsList = Object.values(props.fieldsMapped);
  const fieldsSize = fieldsList.length;

  return (
    <div
      className={twMerge(
        'w-full md:w-[720px] xl:w-[865px] mx-auto flex flex-col gap-4 p-2 md:p-8 text-center justify-center bg-white md:border border-black-300 rounded-lg',
        props.classes,
      )}
    >
      {props.title && (
        <div className={twMerge('font-bold text-[34px] leading-none', props.classes_title)}>{props.title}</div>
      )}
      {props.description && (
        <div className={twMerge('text-[14px] leading-none', props.classes_description)}>{props.description}</div>
      )}
      <div className="relative w-full mx-auto mt-4 grid grid-cols-2 gap-4 md:gap-6 items-start">
        {fieldsList.map((item, index) => {
          const isExpanded =
            (index == fieldsSize - 1 && (index + 1) % 2 > 0) || // Last item and odd index
            ((index + 1) % 2 > 0 && fieldsList[index + 1]?.type === 'comments'); // Odd index and Next item is comments

          return (
            <BaseField
              key={item.type}
              {...item}
              styleClasses={styles}
              wrapperClasses="grow flex flex-col md:flex-row gap-4 md:items-end justify-between"
              extraClasses={isExpanded ? 'col-span-2' : ''}
              locationsOptionSet={props.locationsOptionSet}
              productsListBase={props.products_list}
            >
              {index == fieldsSize - 1 && !props.wasSuccessful && (
                <BaseSubmit
                  {...props}
                  styleClasses="border border-black-500 rounded-md text-[16px] py-2 px-3 leading-4"
                />
              )}
            </BaseField>
          );
        })}
      </div>
      <div className="relative flex flex-col gap-4 w-full mx-auto mt-4">
        {props.display_terms_checkbox && <BaseTermsField {...props} />}
        {props.display_subscribe_checkbox && <BaseSubscribeField {...props} />}
        {props.display_sms_checkbox && <BaseSMSField {...props} />}
      </div>
      <div className="relative w-full mx-auto">
        <BaseMessages {...props} />
      </div>
    </div>
  );
};
